import { UpdateUserDto } from 'types';

export interface UpdateUser extends UpdateUserDto {
  id: number;
}

export interface Permission {
  userId: number;
  analyzerId: number;
}

export interface SnapshotPermission {
  userId: number;
  snapshotId: number;
}

export interface UserForm {
  id?: number | string;
  name?: string;
  email?: string;
  password?: string;
  role?: string | number;
  frozen?: boolean;
}

export enum PermissionActionTypes {
  SNAPSHOT = 'SNAPSHOT',
  ANALYZER = 'ANALYZER',
  RESET = 'RESET',
}

export interface PermissionAction {
  type: PermissionActionTypes;
  checkedState?: { id: number | string; checked: boolean };
  resetState?: Permissions;
}

export interface Permissions {
  permittedAnalyzerIds: number[];
  permittedSnapshotIds: number[];
}
